import React from "react";

import "./ComingSoonPage.css";

const ComingSoonPage = () => {
  return (
    <div className="coming-soon">
      <h1 className="coming-soon-text">Coming soon...</h1>
    </div>
  );
};

export default ComingSoonPage;
